@if (userAuthorizedSubject$ | async) {
  @if (readySubject$ | async) {
    <mat-sidenav-container class="main-app-wrapper w-full" (backdropClick)="drawer.toggle()">
      <mat-sidenav #drawer mode="over" autoFocus=".mat-drawer-inner-container" class="w-[220px] overflow-hidden">
        <div class="my-16 px-4 text-2xl/none leading-tight" notranslate>{{ userName }}</div>
        <a mat-button class="side-menu-item" color="primary" routerLink="/contract" (click)="drawer.toggle()">Enter Time</a>
        <button mat-button type="button" class="side-menu-item" color="accent" (click)="aboutClicked(drawer)">About</button>
        <button mat-button type="button" class="side-menu-item" color="accent" (click)="help(drawer)">Need Help?</button>
        <button mat-button type="button" class="side-menu-item" color="accent" (click)="signOut()">Sign Out</button>
        <a
          mat-button
          class="side-menu-item !mt-8 !flex !justify-start !text-lg"
          color="accent"
          href="https://daveytreeexpert.sharepoint.com/sites/DaveyTimeUtilityOutputs/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDaveyTimeUtilityOutputs%2FShared%20Documents%2FQA%2FChanges"
          target="_blank"
        >
          <mat-icon>open_in_new</mat-icon>
          Documentation
        </a>
        <a
          mat-button
          class="side-menu-item !flex !justify-start !text-lg"
          color="accent"
          target="_blank"
          [href]="generalForemanAppUrl"
        >
          <mat-icon>open_in_new</mat-icon>
          General Foreman
        </a>
      </mat-sidenav>
      <mat-sidenav-content class="main-app-wrapper w-full">
        <mat-toolbar color="primary" class="!mb-2" [ngClass]="environmentCssClass">
          @if (!isProduction) {
            <div
              id="env-info"
              class="absolute left-1/2 top-1 -translate-x-1/2 rounded-b-md px-4 pb-1 text-center leading-none text-white"
              notranslate
            >
              <div id="env-name" class="uppercase">{{ environmentName }}</div>
              @if (!isDevelopment) {
                <div class="cursor-help text-xs/none" [title]="buildDeploymentTitle">
                  {{ buildTimestamp.short }}
                </div>
              }
            </div>
          }
          <button mat-icon-button aria-label="Menu" (click)="drawer.toggle()">
            <mat-icon class="top-bar-icon">menu</mat-icon>
          </button>
          <span notranslate>{{ userName }}</span>
          <span class="flex-auto"></span>
          <button class="!mr-[5px]" mat-icon-button aria-label="Help" (click)="help()">
            <mat-icon svgIcon="help" class="!size-12 !text-3xl/none">help</mat-icon>
          </button>
        </mat-toolbar>
        <main class="app-content-full-height mx-auto max-w-7xl">
          <router-outlet class="app-content-full-height" />
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  } @else {
    <div class="flex h-screen items-center justify-center">
      <mat-spinner />
    </div>
  }
} @else if (readySubject$ | async) {
  <div class="flex h-screen flex-col items-center justify-center !gap-2">
    <div class="!rounded-md !bg-gray-200 !p-20 !text-center !shadow-md">
      <h2 class="!mb-0 !text-3xl/none">There was an issue logging you in</h2>
      <h3 class="!mb-12 !mt-2 !text-xl/none">{{ unauthorizedErrorMessage }}</h3>
      <div class="!flex !flex-row !justify-evenly !gap-2">
        <button mat-raised-button color="primary" (click)="easyTicket()">I Need Help</button>
        <button mat-raised-button>
          <a [href]="landingPageUrl">Go Back</a>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="flex h-screen items-center justify-center">
    <mat-spinner />
  </div>
}
